import React from "react";
import { NavLink } from "react-router-dom";

/**
 * Mobile bottom navigation.
 * Renders on screens < lg. Fixed to bottom, safe-area padding for iOS.
 */
export const BottomNav = ({ items }) => {
  if (!items || !items.length) return null;
  return (
    <nav
      data-testid="mobile-bottom-nav"
      className="lg:hidden fixed bottom-0 left-0 right-0 z-40 border-t glass"
      style={{
        borderColor: "var(--border)",
        paddingBottom: "env(safe-area-inset-bottom)",
      }}
    >
      <div className="grid" style={{ gridTemplateColumns: `repeat(${items.length}, 1fr)` }}>
        {items.map((it) => (
          <NavLink
            key={it.key}
            to={it.to}
            end={it.end}
            data-testid={`mnav-${it.key}`}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center gap-0.5 py-2 transition-colors duration-150 min-h-[56px] ${
                isActive ? "" : "opacity-70"
              }`
            }
            style={({ isActive }) => ({
              color: isActive ? "var(--brand)" : "var(--text-muted)",
              background: isActive ? "rgba(59,130,246,0.06)" : "transparent",
            })}
          >
            <it.icon size={18} />
            <span className="text-[10px] font-medium">{it.label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
};

export default BottomNav;
